import { render, staticRenderFns } from "./PelatihanPreTestReportPeserta.vue?vue&type=template&id=f333581a"
import script from "./PelatihanPreTestReportPeserta.vue?vue&type=script&lang=js"
export * from "./PelatihanPreTestReportPeserta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports